import { combineReducers } from "redux";

import { IProfile, UserID } from "../api/APIClient";
import { RootAction } from "../types";

function data(state: IProfile[] = [], action: RootAction): IProfile[] {
  switch (action.type) {
    case "FETCH_PROFILES_SUCCESS":
      return action.payload;
    case "UPDATE_PROFILE_SUCCESS":
      const updated = action.payload;
      return state.map(profile => {
        if (profile.id === updated.id) {
          return updated;
        }
        return profile;
      });

    case "UPDATE_LINE_REQUEST":
      const { id, addUsers, removeUsers } = action.payload;

      const add = new Set(addUsers);
      const remove = new Set(removeUsers);

      return state.map(profile => {
        const lineSet = new Set(profile.lines);

        if (remove.has(profile.id)) {
          lineSet.delete(id);
        } else if (add.has(profile.id)) {
          lineSet.add(id);
        }

        return {
          ...profile,
          lines: Array.from(lineSet),
        };
      });

    default:
      return state;
  }
}

function modalOpen(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "TOGGLE_USER_MODAL_OPEN":
      return !state;
    case "SHOW_USER_MODAL":
      return true;
    default:
      return state;
  }
}

function selectedID(
  state: UserID | null = null,
  action: RootAction
): UserID | null {
  switch (action.type) {
    case "SHOW_USER_MODAL":
      return action.payload;
    default:
      return state;
  }
}

export const callsReducer = combineReducers({
  data,
  modalOpen,
  selectedID,
});
export default callsReducer;



// WEBPACK FOOTER //
// ./src/reducers/profilesReducer.ts